import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  getLocationListingPath,
  buildYearWiseListingPath,
  persistSelectedPyqYear,
  PAPER_LISTING_PATH,
  withListingTab,
} from "../../../../../custom_utilities/dashboardBannerNavigation";
import images from "../../../../../utilities/images/images";
import TestSyllabusModal from "../../../shared/TestSyllabusModal/TestSyllabusModal";

import "./PaperListing.css";

import {
  fetchExamInstructionRequest,
  setPaperId,
  setTestDetails,
  setTestId,
  setTestType,
  setSelectedSetId,
  submitExamRequest,
} from "../../../../../redux/exam/examSlice";
import { fetchAitsSyllabusRequest } from "../../../../../redux/aits/aitsSlice";
import { getExamInstructionPath } from "../../../pages/bitsatInstructionRoute";

import GameficationMode from "../../../../tests/Dashboard/GameficationMode";
import ResumeModal from "../../../../../shared/components/Modal/ResumeModal/ResumeModal";

const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date)) return "Invalid Date";

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const TestCard = ({ test, isPyq = false }) => {
  const tabName = String(test?.tab_name || "").trim().toLowerCase();
  const isMissedTestCard = tabName === "missed" || tabName === "missed tests";

  const isMockTest = (test.test_name || test.paper_name || "")
    .toLowerCase()
    .includes("mock");
     const isBitsat = String(
    test?.test_name || test?.paper_name || test?.test_type || ""
  )
    .toLowerCase()
    .includes("bitsat");
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { plannerDetails, testDetails, selectedPyqYear } = useSelector(
    (state) => state.examSlice
  );
  const selectedYear = test?.year || selectedPyqYear;
  const listingReturnTo = withListingTab(
    isPyq
      ? buildYearWiseListingPath(selectedYear)
      : getLocationListingPath(location) || PAPER_LISTING_PATH,
    location?.search
  );
  const {
    planner_id,
    planner_type_id,
    id: paperType,
    category_id,
    selectedSetId,
  } = plannerDetails || {};



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showGameMode, setShowGameMode] = useState(false);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const isResumeAttempt =
    test.show_resume === 1 ||
    ((test.is_start_test === 1 && test.is_submited === 0) ||
      (test.is_attempted === 1 && test.is_submited === 0));

  const getTestPayload = ({
    selectedMode,
    gamificationOn,
    forceFreshStart = false,
    isResume = false,
  }) => {
    const testId = test.test_id || test.paper_id;
    if (isPyq && selectedYear) {
      persistSelectedPyqYear(selectedYear);
    }

    return {
      paperId: isPyq ? testId : test.paper_id || testId,
      paperType,
      plannerId: planner_id,
      plannerTypeId: planner_type_id,
      categoryId: category_id || "",
      testId,
      setId: isPyq ? null : test.set_id || selectedSetId || null,
      planner_test_id: testId,
      practiceMode: selectedMode,
      gamificationOn,
      forceFreshStart,
      isResume,
      source: isPyq ? "yearwise" : "paperlisting",
      year: isPyq ? selectedYear : testDetails?.year,
      returnTo: listingReturnTo,
      redirectedFrom: testDetails?.redirectedFrom,
      test_name: test.test_name || test.paper_name || "",
      paper_name: test.paper_name || test.test_name || "",
    };
  };
  const getResumeStorageKey = () => {
    const testId = test.test_id || test.paper_id;
    return `exam_mode_${testId}`;
  };
  const getGamificationStorageKey = () => {
    const testId = test.test_id || test.paper_id;
    return `exam_gamification_${testId}`;
  };
  const getResumeModeConfig = () => {
    const currentTestId = test.test_id || test.paper_id;
    const activeTestId =
      testDetails?.testId || testDetails?.setId || testDetails?.paperId;
    const isSameActiveTest = String(activeTestId) === String(currentTestId);

    const storedMode = localStorage.getItem(getResumeStorageKey());
    const backendMode =
      storedMode ||
      test.practiceMode ||
      test.practice_mode ||
      test.mode ||
      test.selected_mode ||
      test.last_mode ||
      (isSameActiveTest ? testDetails?.practiceMode : undefined);
    const normalizedMode =
      String(backendMode || "").toLowerCase() === "practice"
        ? "practice"
        : "test";
    const storedGamification = localStorage.getItem(getGamificationStorageKey());
    const gamificationOn =
      storedGamification === "1" ||
      test.gamificationOn === true ||
      test.gamification_on === 1 ||
      test.gamification_status === 1 ||
      test.is_gamification === 1 ||
      (isSameActiveTest && testDetails?.gamificationOn === true);

    return {
      selectedMode: normalizedMode,
      gamificationOn: normalizedMode === "practice" ? gamificationOn : false,
    };
  };

  const handleOpenSyllabus = () => {
    dispatch(
      fetchAitsSyllabusRequest({
        paperId: test.paper_id,
        plannerId: planner_id,
      })
    );
    setIsModalOpen(true);
  };
  const toAttemptCount = (value) => {
    const count = Number(value);
    return Number.isFinite(count) ? count : null;
  };
  const usedAttempts =
    toAttemptCount(test?.user_attempt_count ?? test?.attempt_count) ?? 0;
  const maxAttempts = [
    test?.total_attempt_count,
    test?.max_attempt_count,
    test?.max_attempt,
    test?.max_attempts,
    test?.attempt_limit,
    test?.total_attempts,
    test?.attempt_text?.total_attempt_count,
    isBitsat ? 5 : null,
  ]
    .map(toAttemptCount)
    .find((count) => count != null && count > 0);
  const reattemptExceeded =
    maxAttempts != null && usedAttempts >= maxAttempts;

  const isLocked = new Date(test.a) > new Date();
  const handlePdfDownload = () => {
    if (!test.pdf) return;
    window.open(test.pdf, "_blank");
  };

  const handleStart = ({ isReattempt = false } = {}) => {

    if (isLockedByPurchase) {
      history.push(`/package/${test.package_id}`);
      return;
    }

    if (isLocked) return;

    if (!isReattempt && isResumeAttempt) {
      setShowResumeModal(true);
      return;
    }

    if (test.show_practice === 1) {
      setShowGameMode(true);
    } else {
      handleGameModeConfirm({
        selectedMode: "test",
        gamificationOn: false,
      });
    }
  };


  /* -------------------------------
     After Mode Selection
  -------------------------------- */
  const handleGameModeConfirm = ({ selectedMode, gamificationOn }) => {
    const payload = getTestPayload({
      selectedMode,
      gamificationOn,
      forceFreshStart: true,
      isResume: false,
    });
    localStorage.setItem(getResumeStorageKey(), payload.practiceMode || "test");
    localStorage.setItem(
      getGamificationStorageKey(),
      payload.gamificationOn ? "1" : "0"
    );

    dispatch(setTestId(payload.testId));
    dispatch(setTestType({ id: paperType }));
    dispatch(setSelectedSetId(payload.setId));

    dispatch(setTestDetails(payload));

    dispatch(fetchExamInstructionRequest(payload));
    setShowGameMode(false);
    history.push(getExamInstructionPath(payload));
  };

  const handleViewResult = () => {
    const testId = test.test_id || test.paper_id;
    const payload = {
      paperId: isPyq ? testId : test.paper_id || testId,
      paperType,
      plannerId: planner_id,
      plannerTypeId: planner_type_id,
      categoryId: category_id || "",
      testId,
      setId: null,
      planner_test_id: testId,
      practiceMode: "test",
      gamificationOn: false,
      source: isPyq ? "yearwise" : "paperlisting",
      year: isPyq ? selectedYear : testDetails?.year,
      returnTo: listingReturnTo,
      redirectedFrom: testDetails?.redirectedFrom,
      // So analytics "Reattempt" can open the same mode modal as the test card (e.g. after max test attempts).
      show_practice: test.show_practice,
      attempt_message: test.attempt_message,
      user_attempt_count: test.user_attempt_count,
      test_name: test.test_name || test.paper_name || "",
    };

    dispatch(setTestId(payload.testId));
    dispatch(setTestType({ id: paperType }));
    dispatch(setSelectedSetId(null));
    dispatch(setPaperId(payload.paperId));
    dispatch(setTestDetails(payload));

    history.push("/analytics", {
      paper_type: payload.paperType,
      paper_id: payload.paperId,
      planner_test_id: payload.planner_test_id,
      returnTo: listingReturnTo,
    });
  };

  const handleResumeContinue = () => {
    const resumeConfig = getResumeModeConfig();
    const payload = getTestPayload({
      ...resumeConfig,
      forceFreshStart: false,
      isResume: true,
    });

    dispatch(setTestId(payload.testId));
    dispatch(setTestType({ id: paperType }));
    dispatch(setSelectedSetId(payload.setId));
    dispatch(setTestDetails(payload));

    setShowResumeModal(false);
    history.push("/test", {
      paperId: payload.paperId,
      paperType: payload.paperType,
      testId: payload.testId,
      setId: payload.setId,
    });
  };

  const handleResumeSubmit = () => {
    const resumeConfig = getResumeModeConfig();
    const payload = getTestPayload({
      ...resumeConfig,
      forceFreshStart: false,
      isResume: true,
    });

    dispatch(setTestId(payload.testId));
    dispatch(setTestType({ id: paperType }));
    dispatch(setSelectedSetId(payload.setId));
    dispatch(setTestDetails(payload));
    dispatch(
      submitExamRequest({
        paperType: payload.paperType,
        paperId: payload.paperId,
        plannerId: planner_id,
        setId: payload.setId,
        time: 0,
      })
    );
    setShowResumeModal(false);
    history.push(
      payload.practiceMode === "practice" ? "/practice-summary" : "/analytics"
    );
  };
  //   const handleViewResult = () => {
  //   const testId = test.test_id || test.paper_id;
  // dispatch(setSelectedSetId(null));
  //   const payload = {
  //     paperId: test.paper_id || testId,
  //     paperType,
  //     plannerId: planner_id,
  //     plannerTypeId: planner_type_id,
  //     categoryId: category_id || "",
  //     testId,
  //    setId: null,
  //     planner_test_id: testId,
  //     source: isPyq ? "yearwise" : "paperlisting",
  //   };

  //   dispatch(setTestDetails(payload));

  //   history.push("/analytics");
  // };
  // ===== ACCESS TYPE (AITS ONLY) =====
  const isAits = !isPyq;

  const isPurchased = isAits && test.access_type === "Purchased";

  const isFree = isAits && test.free_paid === "Free";

  const isPremium = isAits && test.free_paid === "Paid" && !isPurchased;
  const isLockedByPurchase = isPremium && test.is_purchased === 0;

  return (
    <div className="test_card">
      <div className="testcard_header">
        <div className="left_section">
          {isPurchased && (
            <span className="purchased_tag">
              <img src={images.openlock_icon} alt="purchased" />
              Purchased
            </span>
          )}

          {!isPurchased && isFree && (
            <span className="free_tag">
              <img src={images.lockfree_icon} alt="free" />
              FREE
            </span>
          )}

          {!isPurchased && isPremium && (
            <span className="premium_tag">
              <img src={images.lock_icon} className="lock_icon" alt="premium" />
              PREMIUM
            </span>
          )}
         {!isMockTest && !isBitsat && (
            <span className="major_tag">
              {test.test_type || (isPyq ? "PYQ" : "AITS")}
            </span>
          )}
        </div>
      </div>

      <div className="test_title_container">
        <h3 className="test_title">{test.test_name || test.paper_name}</h3>
        <div className="test_date_row">
          <img src={images.calender_icon} className="calendar_icon" alt="" />
          <span>
            {formatDateTime(
              test.test_date || test.paper_date || test.start_date
            )}
          </span>
        </div>
      </div>

      <div className="rank_marks">
        <div className="combined_row">
          <div className="test_details_row">
            <div className="detail_box">
              <h4>Questions</h4>
              <p>{test.total_questions}</p>
            </div>
            <div className="detail_box">
              <h4>Duration</h4>
              <p>{test.test_duration_min || test.duration_mins} mins</p>
            </div>
            <div className="detail_box">
              <h4>Marks</h4>
              {/* <p>{test.max_marks}</p> */}
              <p>{test.max_marks}</p>
            </div>
          </div>
          {test.is_submited === 1 && (
            <div className="result_section_inline">
              <div className="stat score">
                <div className="stat-top">Score</div>
                <div className="stat-bottom">
                  {test.total_marks ?? "-"}/{test.max_marks ?? "-"}
                </div>
              </div>
              <div className="stat rank">
                <div className="stat-top">Rank</div>
                <div className="stat-bottom">
                  {test.rank === null || test.rank === undefined || test.rank === ""
                    ? "-"
                    : test.rank}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="dotted_line"></div>

      <div className="bottom_content">

        <div className="bottom_links">
          {!isPyq && test.show_syllabus === 1 && (
            <span
              className="bottom_syllabus"
              // onClick={() => setIsModalOpen(true)}
              onClick={handleOpenSyllabus}
            >
              Syllabus
            </span>
          )}

          {/* PYQ → Download PDF */}
          {isPyq && test.pdf && (
            <span className="bottom_syllabus" onClick={handlePdfDownload}>
              Download
            </span>
          )}
        </div>
        {!isPyq && isModalOpen && (
          <TestSyllabusModal onClose={() => setIsModalOpen(false)} />
        )}

        {test.is_submited !== 1 ? (
          <button
            className="start_test_btn"
            onClick={() => handleStart({ isReattempt: false })}
          >
            {isLockedByPurchase || isLocked ? (
              <>
                <img src={images.LockedIcon} className="btn_lock_icon" alt="lock" />
                Locked

              </>
            ) : test.is_submited !== 1 &&
              isResumeAttempt ? (
              getResumeModeConfig().selectedMode === "practice"
                ? "Resume Practice"
                : "Resume Test"
            ) : (
              isMissedTestCard ? "Missed(Start Test)" : "Start Test"
            )}
          </button>
        ) : (
          <div className="completed_buttons">
            {test.is_reattempt === 1 && (
              <button
                className="reattempt_btn"
                onClick={() => {
                  if (reattemptExceeded) return;
                  handleStart({ isReattempt: true });
                }}
                disabled={reattemptExceeded}
              >
                Reattempt
                {`(${test.user_attempt_count ?? 0})`}
              </button>
            )}
            {test.is_submited === 1  && (
              <button className="view_result_btn" onClick={handleViewResult}>
                View Result
              </button>
            )}
          </div>
        )}
      </div>
      <GameficationMode
        isOpen={showGameMode}
        onClose={() => setShowGameMode(false)}
        onConfirm={handleGameModeConfirm}
        attemptMessage={test.attempt_message}
        testName={test.test_name || test.paper_name}
      />
      <ResumeModal
        isOpen={showResumeModal}
        onClose={() => setShowResumeModal(false)}
        onSubmit={handleResumeSubmit}
        onResume={handleResumeContinue}
        resumeLabel={
          getResumeModeConfig().selectedMode === "practice"
            ? "Resume Practice"
            : "Resume Test"
        }
      />
    </div>
  );
};

export default TestCard;
